import { formatDate } from "@angular/common";
import { AlertStatus } from "@models/alerts/alerts-enums";
import { FilterModel } from "ag-grid-enterprise";

export function getInboundFilterModel(): FilterModel {
  const startDay = new Date();
  const endDay = new Date();
  startDay.setHours(0, 0, 0, 0);
  endDay.setHours(23, 59, 59, 59);

  return  {
    status: {
      filterType: 'set',
      values: [AlertStatus.New.toString()]
    },
    createdOn: {
      filterType: "date",
      type: "lessThan",
      dateFrom: formatDate(endDay, 'yyyy-MM-dd HH:mm:ss', 'en-US')
    },
    isRead: {
      filterType: 'set',
      values: ['false']
    }
  }
}
